let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "共享充电订单ID",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "关联预约订单ID",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "共享设备类型",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "充电设备编号/IMEI",
    props: "pileCode",
    minWidth: 280,
  },
  {
    label: "站点名称",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "充电业务归属",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "充电用户账号类型",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "共享充电类型",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "订单状态",
    props: "orderStatusName",
    minWidth: 280,
  },
  {
    label: "订单属性",
    props: "orderPropertyName",
    minWidth: 280,
  },
{
    label: "开始时间",
    props: "beginTime",
    minWidth: 280,
  },

{
    label: "结束时间",
    props: "endTime",
    minWidth: 280,
  },
{
    label: "结束方式",
    props: "chargeOverReason",
    minWidth: 280,
  },
{
    label: "充电时长",
    props: "chargeTime",
    minWidth: 280,
  },
{
    label: "充电电量（kW·h）",
    props: "chargeVal",
    minWidth: 280,
  },
{
    label: "充电预付费用（元）",
    props: "orderNo",
    minWidth: 280,
  },
{
    label: "充电实付费用（元）",
    props: "orderNo",
    minWidth: 280,
  },
{
    label: "已退预付费用（元）",
    props: "orderNo",
    minWidth: 280,
  },
{
    label: "已退实收费用（元）",
    props: "orderNo",
    minWidth: 280,
  },
{
    label: "预付退款状态",
    props: "orderNo",
    minWidth: 280,
  },
{
    label: "预付退款完成时间",
    props: "orderNo",
    minWidth: 280,
  },
{
    label: "备注",
    props: "remark",
    minWidth: 280,
  },
{
    label: "更新人",
    props: "lastModifiedByName",
    minWidth: 280,
  },
{
    label: "更新时间",
    props: "lastModifiedWhen",
    minWidth: 280,
  },
];
pageConfig.unusualListColumns = [
  {
    label: "共享充电订单id",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "充电IMEI编号",
    props: "pileCode",
    minWidth: 200,
  },
  {
    label: "充电业务归属",
    props: "bindSourceName",
    minWidth: 180,
  },
  {
    label: "订单状态",
    props: "orderStatusName",
    minWidth: 150,
  },
  {
    label: "用户手机号",
    props: "custPhone",
    minWidth: 150,
  },
  {
    label: "订单属性",
    props: "orderPropertyName",
    minWidth: 200,
  },
  {
    label: "开始时间",
    props: "beginTime",
    minWidth: 200,
  },
  {
    label: "结束方式",
    props: "chargeOverReason",
    minWidth: 200,
  },
  {
    label: "结束时间",
    props: "endTime",
    minWidth: 200,
  },
  {
    label: "充电时长",
    props: "chargeTime",
    minWidth: 200,
  },
  {
    label: "电费收益（元）",
    props: "actPayFee",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "更新人",
    props: "lastModifiedByName",
    minWidth: 200,
  },
  {
    label: "更新时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
];

//充电记录列表项
pageConfig.chargeRecordColumns = [
  {
    label: "订单编号",
    props: "orderNo",
    minWidth: 200,
  },
  {
    label: "充电桩编号",
    props: "pileCode",
    minWidth: 200,
  },
  {
    label: "用户手机号",
    props: "custPhone",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "账号类型",
    props: "custTypeName",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "开始时间",
    props: "beginTime",
    minWidth: 320,
  },
  {
    label: "结束时间",
    props: "endTime",
    minWidth: 200,
  },
  {
    label: "充电时长（分）",
    props: "chargeTime",
    minWidth: 200,
  },
  {
    label: "订单属性",
    props: "orderPropertyName",
    minWidth: 120,
  },
  {
    label: "充电电量（kW·h）",
    props: "chargeVal",
    minWidth: 200,
  },
];

//抢修列表项
pageConfig.repairColumns = [
  {
    label: "充电桩编号",
    props: "pileCode",
    minWidth: 200,
  },
  {
    label: "维修工单",
    props: "repairNo",
    minWidth: 200,
  },
  {
    label: "所属站点",
    props: "stationName",
    minWidth: 320,
  },
  {
    label: "维修状态",
    props: "repairStatus",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.repairStatus == "01") {
        return "未维修";
      } else {
        return "已维修";
      }
    },
  },
  {
    label: "维修结果",
    props: "repairResult",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.repairResult == "01") {
        return "未修复";
      } else {
        return "已修复";
      }
    },
  },
  {
    label: "申请日期",
    props: "applyTime",
    minWidth: 200,
  },
  {
    label: "维修天数",
    props: "repairDateNum",
    minWidth: 200,
  },
  {
    label: "申请原因",
    props: "applyReason",
    minWidth: 120,
  },
  {
    label: "维修回执",
    props: "corpReturn",
    minWidth: 200,
  },
  {
    label: "维修人",
    props: "repairPerson",
    minWidth: 180,
  },
];

//故障记录列表项
pageConfig.faultRecordColumns = [
  {
    label: "充电桩编码",
    props: "",
    minWidth: 200,
  },
  {
    label: "故障时间",
    props: "",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "故障描述",
    props: "",
    minWidth: 320,
  },
  {
    label: "故障备注",
    props: "",
    minWidth: 200,
  },
];

// 关联账号详情列表
pageConfig.relationColumns = [
  {
    label: "充电桩编码",
    props: "pileCode",
    minWidth: 200,
  },
  {
    label: "关联账号类型",
    props: "custTypeName",
    minWidth: 200,
    tooltip: true,
  },
  {
    label: "用户手机号",
    props: "custPhone",
    minWidth: 200,
  },
  {
    label: "关联时间",
    props: "lastModifiedWhen",
    minWidth: 320,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "共享充电订单",
  },
  {
    type: "title",
    name: "正常订单",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileDetail",
};

// 路由
pageConfig.listRouter = "publicNormalList";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "私桩充电订单",
  },
  {
    type: "router",
    name: "正常订单",
    router: "publicNormalList",
  },
  {
    type: "title",
    name: "订单详情",
  },
];

// 关联账号 详情面包屑
// 详情的面包屑
pageConfig.unusualDetailBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "私桩充电订单",
  },
  {
    type: "router",
    name: "异常订单",
    router: "publicUnusualList",
  },
  {
    type: "title",
    name: "订单详情",
  },
];

pageConfig.formRules = {
  pileCode: [{ required: true, message: "请输入IMEI号", trigger: "blur" }],
  pileTypeNo: [
    { required: true, message: "请选择充电桩型号名称", trigger: "change" },
  ],
  currentOutType: [
    { required: true, message: "请选择电流输出类型", trigger: "change" },
  ],
  gunNum: [{ required: true, message: "请输入充电桩枪数", trigger: "blur" }],
  //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
  optType: [{ required: true, message: "请选择充电桩类型", trigger: "change" }],
  chargingSpeed: [
    { required: true, message: "请选择充电速度", trigger: "change" },
  ],
  interfaceType: [
    { required: true, message: "请选择接口标准", trigger: "change" },
  ],
  applyReason: [{ required: true, message: "请填写申请原因", trigger: "blur" }],
  repairPerson: [{ required: true, message: "请填写维修人", trigger: "blur" }],
  repairStatus: [
    { required: true, message: "请选择维修状态", trigger: "change" },
  ],
  repairResult: [
    { required: true, message: "请选择维修结果", trigger: "change" },
  ],
  repairDateNum: [
    { required: true, message: "请填写维修时间", trigger: "blur" },
  ],
  corpReturn: [
    { required: true, message: "请填写运营商回执", trigger: "blur" },
  ],
};

// ========== 共享用户列表（私桩共享信息详情页 - Tab 6 底部） ==========

// 共享用户类型字典
pageConfig.relationTypeMap = {
  SHARED: '共享',
  BLACKLIST: '黑名单',
  WHITELIST: '白名单',
};

// 共享用户添加方式字典
pageConfig.sourceMap = {
  FAVORITE: '收藏电站',
  CHARGE: '扫码充电',
  RESERVE: '预约充电',
  MANUAL: '手动添加',
  MIGRATION: '数据迁移',
};

// 是否愿意交换车位字典（hasParkSpace: Y/N/空）
pageConfig.hasParkSpaceMap = {
  Y: '是',
  N: '否',
};

// 是否收藏字典（favorite: Y/N）
pageConfig.favoriteMap = {
  Y: '是',
  N: '否',
};

// 用户列表列定义（绑定 custMobile/relationTypeName 等已格式化字段）
pageConfig.shareUserListColumns = [
  { label: '共享用户账号',       props: 'custMobile',          minWidth: 120 },
  { label: '共享用户类型',       props: 'relationTypeName',     minWidth: 100 },
  { label: '共享用户添加方式',   props: 'sourceName',           minWidth: 120 },
  { label: '是否愿意交换车位',   props: 'hasParkSpaceName',     minWidth: 120 },
  { label: '车位信息',           props: 'parkSpace',            minWidth: 100 },
  { label: '使用充电次数',       props: 'usageCount',           minWidth: 100 },
  { label: '是否收藏',           props: 'favoriteName',         minWidth: 80 },
  { label: '创建时间',           props: 'createdWhen',          minWidth: 150 },
  { label: '最新更新时间',       props: 'lastModifiedWhen',     minWidth: 150 },
];

// 变更记录列定义（弹窗内表格）
pageConfig.shareUserRelationLogColumns = [
  { label: '共享用户账号',       props: 'custMobile',              minWidth: 120 },
  { label: '变更前共享用户类型', props: 'beforeRelationTypeName',  minWidth: 140 },
  { label: '变更后共享用户类型', props: 'afterRelationTypeName',   minWidth: 140 },
  { label: '更新时间',           props: 'lastModifiedWhen',        minWidth: 150 },
];

// 用户列表 - 表格属性（不显示多选、显示序号）
pageConfig.shareUserListTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 用户列表 - 分页参数
pageConfig.shareUserListPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 变更记录 - 表格属性（显示序号、不显示多选）
pageConfig.shareUserRelationLogTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 变更记录 - 分页参数
pageConfig.shareUserRelationLogPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50],
};

export default pageConfig;
